import API from './API';

let partnerProvincesCache = null;

export default {

    // Province in cui c'è almeno una sede di un partner: alimentano il
    // menu Booking e il filtro della lista, al posto delle vecchie zone `area`.
    // Menu e lista le chiedono entrambi: una chiamata sola, `force` la rifà
    // (al login). Ogni provincia porta i suoi partner, perché gli spostamenti
    // interni non hanno una sede e si filtrano per partner.
    getPartnerProvinces({ force = false } = {}) {
      if (!force && partnerProvincesCache) return partnerProvincesCache;
      partnerProvincesCache = API.get('/headquarter', {
        params: { join: ['province_ref', 'partner||company_name'], limit: 1000 },
      })
        .then((r) => {
          const byId = new Map();
          for (const h of r.data?.data ?? r.data ?? []) {
            const p = h.province_ref;
            if (!p || !h.partner) continue;
            if (!byId.has(p.id)) {
              byId.set(p.id, { id: p.id, name: p.name, sigla: p.sigla, partnerIds: new Set() });
            }
            byId.get(p.id).partnerIds.add(h.partner.id);
          }
          return [...byId.values()]
            .map((p) => ({ ...p, partnerIds: [...p.partnerIds] }))
            .sort((a, z) => a.name.localeCompare(z.name, 'it'));
        })
        .catch((e) => {
          partnerProvincesCache = null; // un errore non resta in memoria
          throw e;
        });
      return partnerProvincesCache;
    },

    // Albero Regione → Provincia per le tendine. È un dato di SISTEMA
    // (seed ISTAT): si legge e basta, le rotte di scrittura non esistono.
    // ⚠️ Le province sono l'elenco ufficiale, la colonna storica `province`
    // sulle entità è invece la SIGLA: quando si sceglie da qui va tenuta
    // allineata a `sigla`, altrimenti i due dati divergono.
    getRegionsTree() {
      return API.get('/region', {
        params: { join: ['provinces'], sort: 'name,ASC', limit: 50 },
      }).then((r) => r.data?.data ?? r.data ?? []);
    },
}